const productConfig = [
  {
    isShow: false,
    productId: 'pm-diamond1',
    productImg: require('@/assets/images/shop/product/1.jpg'),
    title: '💎1',
    descriptionMd: '',
    primePrice: '',
    price: '$1'
  },
  {
    isShow: false,
    productId: 'pm-diamond3',
    productImg: require('@/assets/images/shop/product/1.jpg'),
    title: '💎2',
    descriptionMd: '',
    primePrice: '',
    price: '$1'
  },

  {
    isShow: true,
    productId: 'pm-diamond580',
    productImg: require('@/assets/images/shop/product/1.jpg'),
    title: '💎580',
    descriptionMd: '',
    primePrice: '',
    price: '$10'
  },
  {
    isShow: true,
    productId: 'pm-diamond1850',
    productImg: require('@/assets/images/shop/product/2.jpg'),
    title: '💎1850',
    descriptionMd: '',
    primePrice: '',
    price: '$29'
  },
  {
    isShow: true,
    productId: 'pm-diamond3000',
    productImg: require('@/assets/images/shop/product/3.jpg'),
    title: '💎3k',
    descriptionMd: '',
    primePrice: '',
    price: '$49'
  },
  {
    isShow: true,
    productId: 'pm-diamond6200',
    productImg: require('@/assets/images/shop/product/4.jpg'),
    title: '💎6.2k',
    descriptionMd: '',
    primePrice: '',
    price: '$99'
  },
  {
    isShow: true,
    productId: 'pm-diamond19k',
    productImg: require('@/assets/images/shop/product/5.jpg'),
    title: '💎19k',
    descriptionMd: '',
    primePrice: '',
    price: '$299'
  },
  {
    isShow: true,
    productId: 'pm-diamond32k',
    productImg: require('@/assets/images/shop/product/6.jpg'),
    title: '💎32k',
    descriptionMd: '',
    primePrice: '',
    price: '$499'
  },
  {
    isShow: true,
    productId: 'pm-diamond64k',
    productImg: require('@/assets/images/shop/product/7.jpg'),
    title: '💎64k',
    descriptionMd: '',
    primePrice: '',
    price: '$999'
  },
  {
    isShow: true,
    productId: 'pm-diamond130k',
    productImg: require('@/assets/images/shop/product/8.jpg'),
    title: '💎130k',
    descriptionMd: '',
    primePrice: '',
    price: '$1999'
  },
  {
    isShow: true,
    productId: 'pm-diamond330k',
    productImg: require('@/assets/images/shop/product/9.jpg'),
    title: '💎330k',
    descriptionMd: '',
    primePrice: '',
    price: '$4999'
  }
]

export default productConfig



// WEBPACK FOOTER //
// ./src/util/product.js